export default "__VITE_ASSET__d1d570c6__"